import { useSyncExternalStore } from 'react';

/**
 * Reactive matchMedia hook. Keeps JS breakpoints in sync with CSS media
 * queries (e.g. the dashboard shell's 1024px mobile flip point).
 */
export function useMediaQuery(query: string): boolean {
  return useSyncExternalStore(
    (onStoreChange) => {
      const mql = window.matchMedia(query);
      mql.addEventListener('change', onStoreChange);
      return () => mql.removeEventListener('change', onStoreChange);
    },
    () => window.matchMedia(query).matches,
    () => false
  );
}

/** Matches the dashboard shell's off-canvas sidebar breakpoint (≤1024px). */
export function useIsMobileViewport(): boolean {
  return useMediaQuery('(max-width: 1024px)');
}
